// Keep in sync with backend/src/vero/constants/vero_cancel_reasons.py

export const VERO_CANCEL_REASONS = [
  "Applicant couldn't confirm their identity",
  "Applicant withdrew",
  "Couldn't reach the applicant",
  "Unit is no longer available",
  "Duplicate application",
  "Something else — add a note",
] as const;

export type VeroCancelReason = (typeof VERO_CANCEL_REASONS)[number];

export const VERO_CANCEL_REASON_IDENTITY: VeroCancelReason =
  "Applicant couldn't confirm their identity";

export const VERO_CANCEL_REASON_SOMETHING_ELSE: VeroCancelReason =
  "Something else — add a note";
